<section class="row">
  <div class="col-md-3">
    <label># of Facilities Used</label>
    <input 
        type="text" 
        pattern="^\$\d{1,3}(,\d{3})*(\.\d+)?$"
        [disabled]="disabled"
        [ngClass]="{'form-control':true, 'has-error': kpi.invalidFields.includes(field.id)}" 
        name="num_used" 
        (keyup)="fillFacilities($event)"
        (blur)="formatNumber($event)"
        [(ngModel)]="answers.num_used" 
    />
  </div>
  <div class="col-md-5">
    <h6>{{ answers.total_stays }} Overnight Stays (Persons Served)</h6>
  </div>



  <ng-container *ngIf="answers.num_used && answers.num_used > 0">
    <div *ngFor="let _ of range(answers.num_used); let i = index" class="row subrow">
      <div class="col-md-3">
        <label>Name of Facility #{{ i + 1 }}</label>
        <input 
          class="form-control"
          type="text" 
          [disabled]="disabled"
          name="facilities_{{i}}_name" 
          [(ngModel)]="answers.facilities[i].name" 
        />
      </div>

      <div class="col-md-3" style="padding-top: 20px">
        <label>
          <input 
            type="radio" 
            name="facilities_{{i}}_type" 
            [(ngModel)]="answers.facilities[i].type" 
            [disabled]="disabled"
            value="Warming" 
          />
          Warming Center
        </label>
        <br>
        <label>
          <input 
            type="radio" 
            name="facilities_{{i}}_type" 
            [(ngModel)]="answers.facilities[i].type" 
            [disabled]="disabled"
            value="Cooling" 
          />
          Cooling Center
        </label>
      </div>

      <div class="col-md-6 row">
        <div class="col-md-6">
          <div>
            <label># of Men</label>
            <input 
              type="text" 
              class="form-control"
              pattern="^\$\d{1,3}(,\d{3})*(\.\d+)?$"
              name="facilities_{{i}}_men" 
              [disabled]="disabled"
              (keyup)="updateCount($event)"
              (blur)="formatNumber($event)"
              [(ngModel)]="answers.facilities[i].men" 
            />
          </div>
        </div>

        <div class="col-md-6">
          <div>
            <label># of Women</label>
            <input 
              type="text" 
              class="form-control"
              pattern="^\$\d{1,3}(,\d{3})*(\.\d+)?$"
              name="facilities_{{i}}_women" 
              [disabled]="disabled"
              (keyup)="updateCount($event)"
              (blur)="formatNumber($event)"
              [(ngModel)]="answers.facilities[i].women" 
            />
          </div>
        </div>

        <div class="col-md-6">
          <div>
            <label># of Children</label>
            <input 
              type="text" 
              class="form-control"
              pattern="^\$\d{1,3}(,\d{3})*(\.\d+)?$"
              name="facilities_{{i}}_children" 
              [disabled]="disabled"
              (keyup)="updateCount($event)"
              (blur)="formatNumber($event)"
              [(ngModel)]="answers.facilities[i].children" 
            />
          </div>
        </div>

        <div class="col-md-6">
          <div>
            <label># of Disabled</label>
            <input 
              type="text" 
              class="form-control"
              pattern="^\$\d{1,3}(,\d{3})*(\.\d+)?$"
              name="facilities_{{i}}_disabled" 
              [disabled]="disabled"
              (keyup)="formatNumber($event)"
              (blur)="formatNumber($event)"
              [(ngModel)]="answers.facilities[i].disabled" 
            />
          </div>
        </div>
      </div>

    </div>
  </ng-container>
</section>



<br>